import { render, staticRenderFns } from "./ModalDugmad.vue?vue&type=template&id=4dd7e9f0&scoped=true"
import script from "./ModalDugmad.vue?vue&type=script&lang=js"
export * from "./ModalDugmad.vue?vue&type=script&lang=js"
import style0 from "./ModalDugmad.vue?vue&type=style&index=0&id=4dd7e9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd7e9f0",
  null
  
)

export default component.exports